import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getDisclosureLevel3,
  saveBatchDisclosureLevel3,
} from '../../api/disclosureLevel3';
import type { DisclosureLevel3 } from '../../types/DisclosureLevel3';
import { t } from '../../i18n/t';

const columnDefs: ColDef<DisclosureLevel3>[] = [
  {
    field: 'parentCodeId',
    headerName: t('disclosureLevel3.columns.parentCodeId'),
    width: 140,
    cellDataType: 'text',
    // Add-only like codeId (Nitzan 30/08/2026): re-parenting a saved code is
    // delete + re-add, mirroring the natural-PK rule.
    editable: (params: EditableCallbackParams<DisclosureLevel3>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
  },
  {
    field: 'codeId',
    headerName: t('disclosureLevel3.columns.codeId'),
    width: 140,
    cellDataType: 'text',
    // String natural PK: editable on Add only, read-only after save. The
    // leading zero must display and round-trip as a string.
    editable: (params: EditableCallbackParams<DisclosureLevel3>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'codeName',
    headerName: t('disclosureLevel3.columns.codeName'),
    flex: 1,
    editable: true,
  },
];

const newRowDefaults = (): Partial<DisclosureLevel3> => ({
  parentCodeId: '',
  codeId: '',
  codeName: '',
});

export function DisclosureLevel3Page() {
  return (
    <LopCrudPage<DisclosureLevel3>
      resourceCode="disclosureLevel3"
      titleKey="disclosureLevel3.pageTitle"
      idField="codeId"
      getRows={getDisclosureLevel3}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchDisclosureLevel3(added, modified, deletedIds as string[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
